// @ts-nocheck

import * as R from 'ramda';
import MainDispatcher from '../../main/support/MainDispatcher';
import dash_api from '../../main/support/dash_api';
import server from '../../main/support/server';

import { ReduxAsyncAction } from '../support/utils';

const GetTwilioNumbers = new ReduxAsyncAction('GET_TWILIO_NUMBERS');
GetTwilioNumbers.registerRequest(function (app_id) {
  return dash_api.get(`/v1/twilio/get-numbers/${app_id}`);
});

export const GET_TWILIO_NUMBERS = GetTwilioNumbers.constants;
export const getTwilioNumbers = GetTwilioNumbers.request;

const PairTwilioAccount = new ReduxAsyncAction('PAIR_TWILIO_APP');
PairTwilioAccount.registerRequest(function (app_id, install_id) {
  return dash_api.post(`/v1/twilio/pair-app`, {
    app_id: app_id,
    install_id: install_id,
  });
});

export const PAIR_TWILIO_APP = PairTwilioAccount.constants;
export const pairTwilioAccount = PairTwilioAccount.request;

export function createAppThroughTwilio(data) {
  MainDispatcher.dispatch({
    action: 'APP_CREATING',
  });

  return server('loggedout/app pair create', R.omit(['apps'], data))
    .then((app_id) => {
      // biome-ignore lint/correctness/noUnusedVariables: ignored using `--suppress`
      return server('loggedout/app set', { next_app_id: app_id }).then((user) => {
        return app_id;
      });
    })
    .catch((e) => {
      return e;
    });
}
